export default __webpack_public_path__ + "media/flags/gg-adb94c9a.svg";